import { z } from "zod";
import { apiListSchema } from "./list";
import {
  createPersonDtoSchema,
  personDtoSchema,
  personFromDto,
  PersonSchema,
  personToDto,
} from "./person";

//? DTO
export const CreateWorkerDtoSchema = z.object({
  Person: createPersonDtoSchema,
  Settings: z.string().nullish(),
});
export type CreateWorkerDto = z.infer<typeof CreateWorkerDtoSchema>;

export const WorkerDtoSchema = CreateWorkerDtoSchema.extend({
  Id: z.number(),
  PersonId: z.number(),
  Person: personDtoSchema,
});
export type WorkerDto = z.infer<typeof WorkerDtoSchema>;

export const workerDtoListSchema = apiListSchema(WorkerDtoSchema);

//? Model

export const CreateWorkerSchema = PersonSchema.extend({
  personId: z.string(),
  settings: z.record(z.string()).nullish(),
});
export type CreateWorker = z.infer<typeof CreateWorkerSchema>;

export const WorkerSchema = CreateWorkerSchema.extend({
  id: z.string().min(1),
});

export type Worker = z.infer<typeof WorkerSchema>;

//? Mappers

export function mapCreateWorkerToDto(worker: CreateWorker): CreateWorkerDto {
  return {
    Person: personToDto(worker),
    Settings: worker.settings ? JSON.stringify(worker.settings) : null,
  };
}

export function mapWorkerFromDto(dto: WorkerDto): Worker {
  return {
    id: dto.Id.toString(),
    personId: dto.PersonId.toString(),
    settings: dto.Settings ? JSON.parse(dto.Settings) : null,
    ...personFromDto(dto.Person),
  };
}

export function mapWorkerToDto(dto: Worker): WorkerDto {
  return {
    Id: Number.parseInt(dto.id),
    PersonId: Number.parseInt(dto.personId ?? ""),
    Person: {
      Id: Number.parseInt(dto.personId ?? ""),
      ...personToDto(dto),
    },
  };
}
